// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.j6LrnJvFkhR5EbPACT3z {
  margin: 0 -12px;
}
@media only screen and (max-width: 1023px) {
  .j6LrnJvFkhR5EbPACT3z {
    margin: 0;
  }
}

.R4rdZO8qHh2xQnBij0IS {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  margin-bottom: 16px;
  background: #F4F4F4;
  border-radius: 8px;
}
.dark-mode .R4rdZO8qHh2xQnBij0IS {
  background: #272B30;
}

.R4rdZO8qHh2xQnBij0IS span {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.7142857143;
  color: #1A1D1F;
  margin-right: auto;
}
.dark-mode .R4rdZO8qHh2xQnBij0IS span {
  color: #FCFCFC;
}

.R4rdZO8qHh2xQnBij0IS button {
  cursor: pointer;
}

.EA_OOSw1Y9n7A655X5rf {
  display: table;
  width: 100%;
}
@media only screen and (max-width: 1023px) {
  .EA_OOSw1Y9n7A655X5rf {
    display: block;
  }
}

.j6S7PQ2VaMeEpju4aAwU {
  display: table-row;
}
.j6S7PQ2VaMeEpju4aAwU.BCml6ZqfLHnuUeC1FsBP .P7LtUAe0fGPQlLLhRWFa:nth-child(2):after {
  right: 12px;
}

.P7LtUAe0fGPQlLLhRWFa {
  position: relative;
  display: table-cell;
  padding: 0 12px 16px;
  vertical-align: middle;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2307692308;
  color: #6F767E;
}
.P7LtUAe0fGPQlLLhRWFa:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 1px;
  background: #EFEFEF;
}
.dark-mode .P7LtUAe0fGPQlLLhRWFa:after {
  background: #272B30;
}

.P7LtUAe0fGPQlLLhRWFa:first-child {
  width: 0px;
  font-size: 0;
}
.P7LtUAe0fGPQlLLhRWFa:first-child:after {
  left: 12px;
}
.P7LtUAe0fGPQlLLhRWFa:last-child:after {
  right: 12px;
}

.ivV91572cb0acEsoBriv {
  margin-top: 20px;
  text-align: center;
}
.ivV91572cb0acEsoBriv .jegmcBopKw4ioSkjvv3d .sD6VLH_OT5yShc0YUkLy {
  transform: scale(0.8);
  margin: 0 18px 0 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/events/details/TicketRequestList/Table/Table.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,eAAA;AADJ;ACWI;EDXJ;IAGQ,SAAA;EACN;AACF;;AAAA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,mBC6BC;ED5BD,kBAAA;AAGJ;AC2Ka;ED5KL,mBC8BH;AD1BL;;AAFI;ECsEA,eAAA;EACA,gBAAA;EACA,yBAAA;EDtEI,cC2BH;ED1BG,kBAAA;AAOR;ACgKa;EDrKD,cCkBP;ADVL;;AANI;EACI,eAAA;AASR;;AAJA;EACI,cAAA;EACA,WAAA;AAOJ;AC3BI;EDkBJ;IAIQ,cAAA;EASN;AACF;;AARA;EACI,kBAAA;AAWJ;AAPgB;EACI,WAAA;AASpB;;AAPA;EACI,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EC6DA,eAAA;EACA,gBAAA;EACA,yBAAA;ED7DA,cCPC;ADmBL;AAXI;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,mBChBH;AD6BL;ACoHa;ED/HD,mBCfP;AD6BL;;AAbI;EACI,UAAA;EACA,YAAA;AAgBR;AAfQ;EACI,UAAA;AAiBZ;AAfQ;EACI,WAAA;AAiBZ;;AAfA;EACI,gBAAA;EACA,kBAAA;AAkBJ;AAhBQ;EACI,qBAAA;EACA,oBAAA;AAkBZ","sourcesContent":["@import ../../../../../styles/helpers\n\n.wrapper\n    margin: 0 -12px\n    +t\n        margin: 0\n\n.bulkActions\n    display: flex\n    align-items: center\n    gap: 12px\n    padding: 12px\n    margin-bottom: 16px\n    background: $n2\n    border-radius: 8px\n    +dark\n        background: $n6\n    \n    span\n        +base2\n        color: $n7\n        margin-right: auto\n        +dark\n            color: $n1\n    \n    button\n        cursor: pointer\n\n.indeterminate\n    // Add styles for indeterminate checkbox state if needed\n\n.table\n    display: table\n    width: 100%\n    +t\n        display: block\n\n.row\n    display: table-row\n    &.active\n        .col\n            &:nth-child(2)\n                &:after\n                    right: 12px\n\n.col\n    position: relative\n    display: table-cell\n    padding: 0 12px 16px\n    vertical-align: middle\n    +caption1\n    color: $n4\n    &:after\n        content: \"\"\n        position: absolute\n        left: 0\n        bottom: 0\n        right: 0\n        height: 1px\n        background: $n3\n        +dark\n            background: $n6\n    &:first-child\n        width: 0px\n        font-size: 0\n        &:after\n            left: 12px\n    &:last-child\n        &:after\n            right: 12px\n    \n.foot\n    margin-top: 20px\n    text-align: center\n    .button\n        .loader\n            transform: scale(.8)\n            margin: 0 18px 0 8px","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `j6LrnJvFkhR5EbPACT3z`,
	"bulkActions": `R4rdZO8qHh2xQnBij0IS`,
	"table": `EA_OOSw1Y9n7A655X5rf`,
	"row": `j6S7PQ2VaMeEpju4aAwU`,
	"active": `BCml6ZqfLHnuUeC1FsBP`,
	"col": `P7LtUAe0fGPQlLLhRWFa`,
	"foot": `ivV91572cb0acEsoBriv`,
	"button": `jegmcBopKw4ioSkjvv3d`,
	"loader": `sD6VLH_OT5yShc0YUkLy`
};
export default ___CSS_LOADER_EXPORT___;
